<div class="tab-container">
  <div class="table-style">
      <p class="table-name sub-form-title no-margin">Users</p>
      <button class="add-dates no-margin" (click)="openDialogForm()"><span class="material-icons plus-icon">
          add
          </span></button> 
  </div> 
  <div *ngIf="!tableData"> No Users Found</div> 
  <app-spinner *ngIf="showSpinner; else content"></app-spinner>     
   <ng-template #content>
  <div *ngIf="tableData?.length" class="box">
  <app-table [tableData]="tableData"  [tableColumnsNames]="columnNames"
  (rowSelected)="selectedItems($event)"></app-table>
 </div>
</ng-template>
</div>
<ng-template #formRef>
 <div class="dialog-Container">
  <mat-dialog-actions  class="d-inline-block float-right">
   <h4 class="d-inline-block">Add New User</h4>
    <button mat-dialog-close class="dialog-btn-trans text-white">X</button>
  </mat-dialog-actions>
  <mat-dialog-content class="dialog-content">
      <p class="sub-form-title mandator-title dialog-sub-title">* All fields are required</p>
      <form class="address-form" action="" [formGroup]="userForm" (submit)="onAddressSubmit()">
          <mat-form-field  appearance="fill">
              <mat-label>User name</mat-label>
              <input [readonly]="isReadonly" matInput formControlName="userName" required/>
              <mat-error *ngIf="userForm.get('userName').hasError('required')">
                 Please enter user name
               </mat-error>
               <mat-error
               *ngIf="!userForm.get('userName').hasError('required') && userForm.get('userName').hasError('patternValidation')">
               Special characters or spaces not allowed at the start and min length is 2
             </mat-error>
           </mat-form-field> 
           <mat-form-field appearance="fill">
            <mat-label>Email</mat-label>
            <input matInput formControlName="email" required pattern="^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$"/>
            <mat-error *ngIf="userForm.get('email').hasError('required') || userForm.get('email').hasError('pattern')">
              Please enter email
            </mat-error>
          </mat-form-field>
           <mat-form-field  appearance="fill" *ngIf="!selectedItem">
              <mat-label>Password</mat-label>
              <input #passwordField matInput formControlName="password" type="password" required/>
              <span  toggle="#password-field"
              class="fa password-visible field-icon toggle-password"
              [title]="showPassword ? 'hide password' : 'show password'"
              [ngClass]="{'fa-eye': showPassword, 'fa-eye-slash': !showPassword}"
              (click)="togglePassword()"></span>
              <mat-error *ngIf="userForm.get('password').hasError('required')">
                 Please enter password   
               </mat-error>
               <mat-error *ngIf="password?.length < 6 && !userForm.get('password').hasError('required')">
                Password length is too short
              </mat-error>
           </mat-form-field> 
           <mat-form-field  appearance="fill">
              <mat-label>Role</mat-label>
              <mat-select formControlName="role" multiple>
                <mat-option  *ngFor="let role of roles"  [value]="role.id">{{role.name}}</mat-option>
              </mat-select>
              <mat-error *ngIf="userForm.get('role').hasError('required')">
                 Please select role    
               </mat-error>
               <mat-error *ngIf="!userForm.get('role').hasError('required') && userForm.get('role').hasError('patternValidation')">
                Special character or space not allow at start
              </mat-error>
               <!-- <mat-error *ngIf="!userForm.get('role').hasError('required') && userForm.get('role').hasError('patternValidation')">
                Special character not allow  
              </mat-error> -->
           </mat-form-field>
           <button mat-button *ngIf="!selectedItem" style="margin-top:12px;" class="button-primary"  [disabled]='userForm.invalid || btndisabled' type="submit" color="vov-ui-primary">Submit</button>
           <button mat-button *ngIf="selectedItem" style="margin-top:12px;" class="button-primary" [disabled]='userForm.invalid || btndisabled' type="submit" (click)="editAddress($event)" color="vov-ui-primary">Update</button>
      </form>
  </mat-dialog-content>
 </div>
</ng-template>
<ng-template #confirmRef>
  <div class="dialog-Container">
      <h3 mat-dialog-title>Are you sure you want to delete?</h3>
  <mat-dialog-content class="delete-Conatiner">
      <button mat-button color="vov-ui-primary" class="confirm-btn confirm" (click)="confirmDelete($event)">Delete</button>
      <button mat-button (click)="onNoClick()" class="confirm-btn" tabindex="-1">Cancel</button>
    </mat-dialog-content>
  </div>
</ng-template> 